import { Injectable } from '@angular/core'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { Observable } from 'rxjs'
import { COLLECTIONS } from 'shared-lib'
import { IAssistantConversation } from '../models/assistant.model'

/**
 * Live-listener store for the assistant conversation (CAP-2). Backed by
 * `@engineering11/web-api-firebase` `CollectionRepository`; `getValueChanges` yields the doc and
 * every subsequent Firestore change, so the panel renders messages/steps in place with no polling.
 */
@Injectable({ providedIn: 'root' })
export class AssistantConversationRepository extends CollectionRepository<IAssistantConversation> {
  // BACKEND CONTRACT (assumption) — see ../BACKEND-CONTRACT.md
  protected COLLECTION = COLLECTIONS.ASSISTANT_CONVERSATION

  /** Live conversation document. Emits the current doc and every Firestore update. */
  liveConversation(id: string): Observable<IAssistantConversation | undefined> {
    return this.getValueChanges(id)
  }
}
